import { Button } from 'reactstrap';

export type FilterOption = {
  id: number;
  name: string;
};

type FilterOptionGroupProps = {
  title: string;
  options: FilterOption[];
  activeIds: number[];
  disabledIds: number[];
  columns?: number;
  onToggle: (optionId: number) => void;
};

const FilterOptionGroup = ({
  title,
  options,
  activeIds,
  disabledIds,
  columns = 2,
  onToggle,
}: FilterOptionGroupProps) => (
  <div className="p-3">
    <h2 className="title-medium semi-bold mb-m">{title}</h2>
    <div className="grid text-center" style={{ '--bs-columns': columns } as React.CSSProperties}>
      {options.map((option) => {
        const isActive = activeIds.includes(option.id);
        const isDisabled = disabledIds.includes(option.id);

        return (
          <Button
            key={option.id}
            size="sm"
            color={isActive ? 'primary' : 'secondary'}
            outline={!isActive}
            disabled={isDisabled}
            onClick={() => onToggle(option.id)}
            className="w-100"
          >
            {option.name}
          </Button>
        );
      })}
    </div>
  </div>
);

export default FilterOptionGroup;
